module.exports = __webpack_public_path__ + "media/app/assets/imgs/events/privacy-public-6ca1bc938c391dcfd3c669e1e66088b8.png";